export const SHELL_ORIGINS: string[] = [
  'https://app.biztada.com',
  'https://biztada.com',
  'https://www.biztada.com',
  'https://review.biztada.com',
  'https://app-biztada.tadagram.com',
  'https://app-biztada.pages.dev',
  'http://localhost:5173',
  'http://localhost:3000',
];

export const getIframeParentOrigin = (): string | null => {
  if (window === window.parent) return null;
  const referrer = document.referrer;
  if (!referrer) return null;
  try {
    return new URL(referrer).origin;
  } catch {
    return null;
  }
};

export const isTrustedShellOrigin = (origin: string): boolean => {
  if (SHELL_ORIGINS.includes(origin)) return true;
  const parentOrigin = getIframeParentOrigin();
  return !!parentOrigin && parentOrigin === origin;
};
